<page-loader *ngIf="!isLoaded"></page-loader>
<div id="page-user-listing" class="page-section client-list-page-section">
    <div class="page-section">
        <div class="app-l-page-wrap">
            <div class="app-l-page__navigation">
                <div class="app-l-page__previous" [routerLink]="['/app']">
                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                        <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
                    </button>
                </div>
                <div class="app-l-page__breadcrumbs">
                    <ul class="breadcrumbs-list">
                        <li translate class="breadcrumbs-list-item">
                            <a [routerLink]="['/app']" translate>menu.dashboard</a>
                        </li>
                        <li class="breadcrumbs-list-item app-l-current-page" translate>
                            menu.myTeam
                        </li>
                    </ul>
                </div>
            </div>
            <div class="app-l-room__wrap" *ngIf="isLoaded">
                <h2 class="app-c-body-text--20-bold client-list-heading" translate>
                    menu.myTeam
                </h2>
                <div class="app-l-client_list">
                    <div class="app-l-list__actions" *ngIf="myTeamList || myTeamList.length > 0">
                        <!-- <div class="app-l-list__actions-block">
                            <select
                                class="app-c-form-control app-l-dsh__rfp-select"
                                [(ngModel)]="selectedType"
                                (change)="getMyteam()">
                                <option value="all" translate>All</option>
                                <option
                                    *ngFor="let users of userRole"
                                    [value]="users.key">
                                    {{ users.title | translate }}
                                </option>
                            </select>
                        </div> -->

                                                <div class="app-l-list__actions-block">
    <div class="app-c-custom-select" [class.is-open]="isTypeOpen">
        <div
            class="app-c-select-trigger app-c-form-control"
            role="combobox"
            aria-haspopup="listbox"
            aria-autocomplete="none"
            aria-label="Filter team members by role"
            aria-controls="team-role-options"
            [attr.aria-expanded]="isTypeOpen"
            tabindex="0"
            (click)="isTypeOpen = !isTypeOpen"
            (keydown.enter)="isTypeOpen = !isTypeOpen"
            (keydown.space)="$event.preventDefault(); isTypeOpen = !isTypeOpen"
            (keydown.escape)="isTypeOpen = false">
      <span>
        <ng-container *ngIf="selectedType === 'all'">{{ 'All' | translate }}</ng-container>
        <ng-container *ngFor="let users of userRole">
          <ng-container *ngIf="selectedType === users.key">{{ users.title | translate }}</ng-container>
        </ng-container>
      </span>
    </div>

        <ul id="team-role-options" class="app-c-select-list" *ngIf="isTypeOpen" role="listbox" aria-label="Team member role options">
      <li [class.is-selected]="selectedType === 'all'"
                    role="option"
                    tabindex="0"
                    [attr.aria-selected]="selectedType === 'all'"
                    (click)="selectedType = 'all'; isTypeOpen = false; getMyteam()"
                    (keydown.enter)="selectedType = 'all'; isTypeOpen = false; getMyteam()"
                    (keydown.space)="$event.preventDefault(); selectedType = 'all'; isTypeOpen = false; getMyteam()">
        {{ 'All' | translate }}
      </li>
      <li *ngFor="let users of userRole"
          [class.is-selected]="selectedType === users.key"
                    role="option"
                    tabindex="0"
                    [attr.aria-selected]="selectedType === users.key"
                    (click)="selectedType = users.key; isTypeOpen = false; getMyteam()"
                    (keydown.enter)="selectedType = users.key; isTypeOpen = false; getMyteam()"
                    (keydown.space)="$event.preventDefault(); selectedType = users.key; isTypeOpen = false; getMyteam()">
        {{ users.title | translate }}
      </li>
    </ul>
  </div>
</div>
                    </div>
                    <div class="app-l-room__tabs client-list-tab-section">
                        <div class="app-dm-positive-cards-wrapper" *ngIf="myTeamList || myTeamList.length > 0">
                            <div class="table-responsive">
                                <table class="table list-custom-table">
                                    <thead class="list-custom-table-header">
                                        <tr>
                                            <th class="list-custom-table-head list-custom-table-head-first" translate>
                                                myTeam.name
                                            </th>
                                            <th class="list-custom-table-head" translate>
                                                myTeam.role
                                            </th>
                                            <th class="list-custom-table-head" translate>
                                                myTeam.email
                                            </th>
                                            <th class="list-custom-table-head list-custom-table-head-last" *ngIf = "user.userType !== 'professional'" translate>
                                                myTeam.action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="list-custom-table-body">
                                        <ng-container *ngFor="let myteam of myTeamList; let i = index">
                                        <tr  *ngIf="(i === 0 || myTeamList[i - 1].UserType !== myteam.UserType || myTeamList[i - 1].Type !== myteam.Type) && selectedType === 'all'">
                                            <td colspan="4" class="role-header">
                                                {{ (getUserRoleTitle(myteam.UserType, myteam.Type) | lowercase) | titlecase }}
                                            </td>
                                        </tr>
                                        <tr [ngClass]="{
                                                        highlighted:
                                                            user.isPaired
                                                    }">
                                            <td class="strong">
                                                {{
                                                    myteam.Name
                                                ? myteam.Name
                                                : ''
                                                }}
                                            </td>
                                            <td>{{ getUserRoleTitle(myteam.UserType, myteam.Type) }}</td>
                                            <td>
                                                {{
                                                    myteam.Email
                                                }}
                                            </td>
                                            <td *ngIf = "user.userType !== 'professional'">
                                                <div class="action-buttons-section">
                                                    <button class="app-c-btn app-c-btn--icon app-c-btn--icon-primary"
                                                        tabindex="0" (click)="
                                                                    deleteInvitation(
                                                                        myteam.ID
                                                                    )
                                                                " (keypress)="
                                                                    deleteInvitation(
                                                                        myteam.ID
                                                                    )
                                                                " translate>
                                                        <svg-icon icon="trash" alt="trash"></svg-icon>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <p *ngIf="isLoaded && myTeamList.length === 0" class="center">
                            <span translate>myTeam.noDataFound</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>